<div class="main-container">
  <app-chat></app-chat>
  <div class="footer logo">
      made with <img src="assets/digital_heart.png"> by&nbsp;<a href="https://omm-solutions.de" target="_blank">omm solutions</a>
  </div>
</div>
